import { createSelector } from 'reselect';
import Constants from './constants';

const STATE_KEY_NAME = Constants.MODULE_NAME;

const stateSelector = (state) => state[STATE_KEY_NAME];

const loginIsSubmittingSelector = createSelector(stateSelector, (state) => state.isSubmitting);
const loginErrorSelector = createSelector(stateSelector, (state) => state.error);
const loginRequiresCaptchaSelector = createSelector(stateSelector, (state) => state.requiresCaptcha);
const loginSsoProvidersSelector = createSelector(stateSelector, (state) => state.ssoProviders);

export const LoginSelectors = {
  loginIsSubmittingSelector,
  loginErrorSelector,
  loginRequiresCaptchaSelector,
  loginSsoProvidersSelector,
};
